import {$util,$array} from "@util/util.js";
import BaseView from "@core/View.js";
import Alert from "@util/alert_wap.js";

export default class OptionWapView extends BaseView{
    constructor(model){
        super(model);
        this._model._view = this;
        this._parentEl = this._model._parent._view._extraBoxEl;
        this._optionBoxEl = this._model._parent._view._optionBoxEl;
        this._optionBoxEls = this._model._parent._view._optionBoxEls;
    }

    getReduceBtnDisabled(item){
        if(item._count == 1){
            return "disabled";
        }
        return "";
    }

    getMaxBtnDisabled(item){
        if(item._count >= this._model.getMaxBuyCount(item) ){
            return "disabled";
        }
        return "";
    }

    getItems(){
        let html = "";
        this._model._items.forEach((item) => {          
            html += `<div class="item_content ${this.getInvalidInfo(item).cls}">
                <div  class="e_goods_img">
                    <img src="${item._img}">
                    <div class="disable_img"></div>
                </div>
                <div class="e_goods_desc">
                    <span style="display:${(this._model._parent._invalid || item._invalid || !this._model._parent._marketable || this._model._parent._stock <= 0 ) ? 'inline-block':'none'}" class="le_tip_btn_solid">${this.getInvalidInfo(item).msg}</span>
                    <h6 class='lenovo-emoji' style="opacity:${(this._model._parent._invalid || item._invalid || !this._model._parent._marketable || this._model._parent._stock <= 0 ) ? '0.5' : '1'}">${item._name}</h6>
                    <span style="opacity:${(this._model._parent._invalid || item._invalid || !this._model._parent._marketable || this._model._parent._stock <= 0 ) ? '0.5' : '1'}" class="e_price">¥${item._price}</span>
                    <span style="opacity:${(this._model._parent._invalid || item._invalid || !this._model._parent._marketable || this._model._parent._stock <= 0 ) ? '0.5' : '1'}" class="e_num">&nbsp;x&nbsp;${item._count}</span>
                </div>
            </div>`;
        });
        return html;
    }

    render(){
        let tmpId = this._model.__tempId + "_" + this._model._parent._id + '_' +this._model._parent._itemId;
        let html = "";
        html += `<div class="clearfix extra_item option ${this.getInvalidInfo().cls}" skuid='${tmpId}'>
            <h3 class="e_name">选件`
            // if(!this._model._parent._invalid) {
            //     html+= `<span class="fr e_action">重选<i class="iconfont icon-arrow-right le_vertical_align_m"></i>
            //     </span>`;
            // }
            html+=`</h3>
            <div class="extra_item_content">${this.getItems()}</div>            
        </div>`;       
        $(this._parentEl).append($(html));
        
        this._el = $("div.option[skuid='"+tmpId+"']");
        this.regEvent();
    }

    regEvent(){
        let that = this;
         // 选择选件
         this._el.off("click", "span.e_action").on("click", "span.e_action", function () {                 
            that._model._parent.getOptionGoods().then(
                x=>{                       
                    that._model._parent._optionList._view.render();
                    $('div.option_wrapper').show();    
                    $util.toggleBodyScroller(true);            
                }
            ).catch(err=>{
                $('div.option_wrappers').show();  
                $util.toggleBodyScroller(true);
                $(".option_Title").html(`选择选件<i class="fr iconfont icon-close" tag="optionhide"></i>`)
                $(".optionsNone_text").html(`暂无选件`)  
            });
        })
        this._optionBoxEls.off("click", "[tag='optionhide']").on("click", "[tag='optionhide']", function () {                 
            $('div.option_wrappers').hide();  
            $util.toggleBodyScroller(false);
        })
        
    }
  
}